//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../axios-client';
import { getAxios, getBaseUrl } from './helpers';

/**
 * @param filter (optional) 
 * @param type (optional) 
 * @param dataSource (optional) 
 * @param sorting (optional) 
 * @param skipCount (optional) 
 * @param maxResultCount (optional) 
 * @return OK
 */
export function assetsGetList(filter?: string | undefined, type?: Types.AssetType[] | undefined, dataSource?: Types.DataSource[] | undefined, sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PagedResultDtoOfAdminAssetDto> {
    let url_ = getBaseUrl() + "/api/assets?";
    if (filter === null)
        throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
        url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
    if (type === null)
        throw new Error("The parameter 'type' cannot be null.");
    else if (type !== undefined)
        type && type.forEach(item => { url_ += "Type=" + encodeURIComponent("" + item) + "&"; });
    if (dataSource === null)
        throw new Error("The parameter 'dataSource' cannot be null.");
    else if (dataSource !== undefined)
        dataSource && dataSource.forEach(item => { url_ += "DataSource=" + encodeURIComponent("" + item) + "&"; });
    if (sorting === null)
        throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
        url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
        throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
        url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
        throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
        url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigAssetsGetList,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigAssetsGetList?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAssetsGetList(_response);
    });
}

function processAssetsGetList(response: AxiosResponse): Promise<Types.PagedResultDtoOfAdminAssetDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.PagedResultDtoOfAdminAssetDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PagedResultDtoOfAdminAssetDto>(null as any);
}

/**
 * @return OK
 */
export function assetsGet(id: string, config?: AxiosRequestConfig | undefined): Promise<Types.AssetDto> {
    let url_ = getBaseUrl() + "/api/assets/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigAssetsGet,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigAssetsGet?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAssetsGet(_response);
    });
}

function processAssetsGet(response: AxiosResponse): Promise<Types.AssetDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.AssetDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.AssetDto>(null as any);
}

/**
 * @return OK
 */
export function assetsGetEvents(id: string, config?: AxiosRequestConfig | undefined): Promise<Types.ListResultDtoOfAssetEventDto> {
    let url_ = getBaseUrl() + "/api/assets/{id}/events";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigAssetsGetEvents,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigAssetsGetEvents?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAssetsGetEvents(_response);
    });
}

function processAssetsGetEvents(response: AxiosResponse): Promise<Types.ListResultDtoOfAssetEventDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.ListResultDtoOfAssetEventDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ListResultDtoOfAssetEventDto>(null as any);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function assetsSearch(body?: Types.AssetSearchInput | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ExternalAssetSearchDto[]> {
    let url_ = getBaseUrl() + "/api/assets/search";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigAssetsSearch,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigAssetsSearch?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAssetsSearch(_response);
    });
}

function processAssetsSearch(response: AxiosResponse): Promise<Types.ExternalAssetSearchDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.ExternalAssetSearchDto[]>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ExternalAssetSearchDto[]>(null as any);
}

/**
 * @param maxResultCount (optional) 
 * @return OK
 */
export function assetsSearchV2(searchTerm: string, assetTypes: Types.AssetType[], maxResultCount?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ListResultDtoOfExternalAssetSearchDto> {
    let url_ = getBaseUrl() + "/api/assets/search?";
      if (searchTerm === undefined || searchTerm === null)
        throw new Error("The parameter 'searchTerm' must be defined and cannot be null.");
      else
        url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
      if (assetTypes === undefined || assetTypes === null)
        throw new Error("The parameter 'assetTypes' must be defined and cannot be null.");
      else
        assetTypes && assetTypes.forEach(item => { url_ += "AssetTypes=" + encodeURIComponent("" + item) + "&"; });
    if (maxResultCount === null)
        throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
        url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigAssetsSearchV2,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigAssetsSearchV2?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAssetsSearchV2(_response);
    });
}

function processAssetsSearchV2(response: AxiosResponse): Promise<Types.ListResultDtoOfExternalAssetSearchDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.ListResultDtoOfExternalAssetSearchDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ListResultDtoOfExternalAssetSearchDto>(null as any);
}

/**
 * @param start (optional) 
 * @param end (optional) 
 * @return OK
 */
export function assetsGetChart(identifier: string, dataSource: Types.DataSource, start?: string | undefined, end?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ListResultDtoOfAssetTimeSeriesEntryDto> {
    let url_ = getBaseUrl() + "/api/assets/chart?";
      if (identifier === undefined || identifier === null)
        throw new Error("The parameter 'identifier' must be defined and cannot be null.");
      else
        url_ += "Identifier=" + encodeURIComponent("" + identifier) + "&";
      if (dataSource === undefined || dataSource === null)
        throw new Error("The parameter 'dataSource' must be defined and cannot be null.");
      else
        url_ += "DataSource=" + encodeURIComponent("" + dataSource) + "&";
    if (start === null)
        throw new Error("The parameter 'start' cannot be null.");
    else if (start !== undefined)
        url_ += "Start=" + encodeURIComponent("" + start) + "&";
    if (end === null)
        throw new Error("The parameter 'end' cannot be null.");
    else if (end !== undefined)
        url_ += "End=" + encodeURIComponent("" + end) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigAssetsGetChart,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigAssetsGetChart?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAssetsGetChart(_response);
    });
}

function processAssetsGetChart(response: AxiosResponse): Promise<Types.ListResultDtoOfAssetTimeSeriesEntryDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.ListResultDtoOfAssetTimeSeriesEntryDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ListResultDtoOfAssetTimeSeriesEntryDto>(null as any);
}

/**
 * @param start (optional) 
 * @param end (optional) 
 * @return OK
 */
export function assetsGetChartById(id: string, start?: string | undefined, end?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ListResultDtoOfAssetTimeSeriesEntryDto> {
    let url_ = getBaseUrl() + "/api/assets/{id}/chart?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (start === null)
        throw new Error("The parameter 'start' cannot be null.");
    else if (start !== undefined)
        url_ += "Start=" + encodeURIComponent("" + start) + "&";
    if (end === null)
        throw new Error("The parameter 'end' cannot be null.");
    else if (end !== undefined)
        url_ += "End=" + encodeURIComponent("" + end) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigAssetsGetChartById,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigAssetsGetChartById?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAssetsGetChartById(_response);
    });
}

function processAssetsGetChartById(response: AxiosResponse): Promise<Types.ListResultDtoOfAssetTimeSeriesEntryDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.ListResultDtoOfAssetTimeSeriesEntryDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ListResultDtoOfAssetTimeSeriesEntryDto>(null as any);
}
let _requestConfigAssetsGetList: Partial<AxiosRequestConfig> | null;
export function getAssetsGetListRequestConfig() {
  return _requestConfigAssetsGetList;
}
export function setAssetsGetListRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAssetsGetList = value;
}
export function patchAssetsGetListRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAssetsGetList = patch(_requestConfigAssetsGetList ?? {});
}

let _requestConfigAssetsGet: Partial<AxiosRequestConfig> | null;
export function getAssetsGetRequestConfig() {
  return _requestConfigAssetsGet;
}
export function setAssetsGetRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAssetsGet = value;
}
export function patchAssetsGetRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAssetsGet = patch(_requestConfigAssetsGet ?? {});
}

let _requestConfigAssetsGetEvents: Partial<AxiosRequestConfig> | null;
export function getAssetsGetEventsRequestConfig() {
  return _requestConfigAssetsGetEvents;
}
export function setAssetsGetEventsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAssetsGetEvents = value;
}
export function patchAssetsGetEventsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAssetsGetEvents = patch(_requestConfigAssetsGetEvents ?? {});
}

let _requestConfigAssetsSearch: Partial<AxiosRequestConfig> | null;
export function getAssetsSearchRequestConfig() {
  return _requestConfigAssetsSearch;
}
export function setAssetsSearchRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAssetsSearch = value;
}
export function patchAssetsSearchRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAssetsSearch = patch(_requestConfigAssetsSearch ?? {});
}

let _requestConfigAssetsSearchV2: Partial<AxiosRequestConfig> | null;
export function getAssetsSearchV2RequestConfig() {
  return _requestConfigAssetsSearchV2;
}
export function setAssetsSearchV2RequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAssetsSearchV2 = value;
}
export function patchAssetsSearchV2RequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAssetsSearchV2 = patch(_requestConfigAssetsSearchV2 ?? {});
}

let _requestConfigAssetsGetChart: Partial<AxiosRequestConfig> | null;
export function getAssetsGetChartRequestConfig() {
  return _requestConfigAssetsGetChart;
}
export function setAssetsGetChartRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAssetsGetChart = value;
}
export function patchAssetsGetChartRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAssetsGetChart = patch(_requestConfigAssetsGetChart ?? {});
}

let _requestConfigAssetsGetChartById: Partial<AxiosRequestConfig> | null;
export function getAssetsGetChartByIdRequestConfig() {
  return _requestConfigAssetsGetChartById;
}
export function setAssetsGetChartByIdRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAssetsGetChartById = value;
}
export function patchAssetsGetChartByIdRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAssetsGetChartById = patch(_requestConfigAssetsGetChartById ?? {});
}